// Central event config — easy to customize.
// The main baptism date is used for the countdown timer.

export const HONOREE = "Odysseas Omid";

// The countdown targets this date (the main ceremony day).
// Replace with the real date/time when known.
export const MAIN_EVENT_ISO = "2026-09-12T18:00:00";

export const EVENTS = [
  {
    key: "day1",
    label: "Day One",
    title: "Welcome Dinner",
    date: "Thursday, September 10 · 2026",
    time: "8:00 PM",
    venue: "To Chryso · Artemonas, Sifnos",
    address: "A relaxed dinner to begin the celebrations",
    description:
      "We open the three days with a long, easy dinner at To Chryso in Artemonas — a chance to gather, share a glass, and welcome everyone to Sifnos.",
    accent: "Arrival & Welcome",
    start: "2026-09-10T20:00:00+03:00",
    end: "2026-09-10T23:30:00+03:00",
    image:
      "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/d233q5gy_IMG_2569.png",
    imageAlt: "To Chryso restaurant courtyard at dusk, Artemonas Sifnos",
    mapQuery: "To Chryso restaurant Artemonas Sifnos Greece",
    mapsLink:
      "https://www.google.com/maps/search/?api=1&query=To+Chryso+Artemonas+Sifnos",
  },
  {
    key: "day2",
    label: "Day Two",
    title: "Persian Night",
    date: "Friday, September 11 · 2026",
    time: "Evening",
    venue: "Location to be announced",
    address: "Sifnos · venue TBD",
    description:
      "A long night of dancing under the stars with sets from an Iranian DJ — Persian rhythms meeting the Cycladic breeze. Stay tuned, the venue will be shared soon.",
    accent: "Music & Dancing",
    start: "2026-09-11T22:00:00+03:00",
    end: "2026-09-12T03:00:00+03:00",
  },
  {
    key: "day3",
    label: "Day Three",
    title: "Holy Baptism & Reception",
    date: "Saturday, September 12 · 2026",
    time: "6:00 PM",
    venue: "Monastery of Panagia Chrysopigi · Sifnos",
    address: "The sacred ceremony by the sea",
    description:
      "The day begins with the sacrament of Holy Baptism at the Monastery of Panagia Chrysopigi, perched above the Aegean.",
    accent: "The Sacred Day",
    start: "2026-09-12T18:00:00+03:00",
    end: "2026-09-12T19:30:00+03:00",
    image:
      "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/ymryixpb_IMG_0359.png",
    imageAlt: "Monastery of Panagia Chrysopigi, Sifnos",
    mapQuery: "Monastery of Panagia Chrysopigi Sifnos Greece",
    mapsLink:
      "https://www.google.com/maps/search/?api=1&query=Panagia+Chrysopigi+Monastery+Sifnos",
    secondary: {
      eyebrow: "Then · The Celebration",
      title: "Reception Party",
      time: "8:00 PM — 5:00 AM",
      venue: "Lazarou Beach Venue · Sifnos",
      description:
        "Dinner, drinks, and dancing by the sea — we'll celebrate together until the first light of morning.",
      start: "2026-09-12T20:00:00+03:00",
      end: "2026-09-13T05:00:00+03:00",
      image:
        "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/7qt96w2s_LAZAROU-BEACH-WEDDING-VENUE-IN-GREECE-30.jpg",
      imageAlt: "Lazarou Beach Venue at night, Sifnos",
      mapQuery: "Lazarou Beach Sifnos Greece",
      mapsLink:
        "https://www.google.com/maps/search/?api=1&query=Lazarou+Beach+Sifnos",
    },
  },
];

export const VERSE = {
  text:
    "Let the little children come to me, and do not hinder them, for the kingdom of heaven belongs to such as these.",
  attribution: "— Matthew 19:14",
};

export const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/ikqp85rk_odysseas%20landscape.png",
    alt: "Odysseas — a moment of stillness",
    span: "md:col-span-12",
    ratio: "aspect-[16/9]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/fw7ic3lt_att.uLi8chkWaqfVtrYzeaiEPEI13ltCBK5IGFyy_nMqaJs.png",
    alt: "Held in love",
    span: "md:col-span-6",
    ratio: "aspect-square",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/fhe85njp_att.Tg6loumobdrMd75oFLNCos_HG_o_iuoNZ7lH_3eb2b0.png",
    alt: "Wide-eyed wonder",
    span: "md:col-span-6",
    ratio: "aspect-square",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/oe5745pl_IMG_4122.png",
    alt: "Sweet smile",
    span: "md:col-span-6",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/roe0vhr9_aristotelis_odysseas.png",
    alt: "Aristotelis & Odysseas",
    span: "md:col-span-6",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/l214iql9_IMG_4067.png",
    alt: "A quiet glance",
    span: "md:col-span-6",
    ratio: "aspect-[4/5]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_holy-milestone/artifacts/uhoo2w52_IMG_4976.png",
    alt: "Little dinosaurs",
    span: "md:col-span-6",
    ratio: "aspect-[4/5]",
  },
];

export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/e7cab7d0-265b-4a1d-b389-c4d6a5e9545b/images/8136b579ec23520dc5ceea437468a4fafd06c2e1d6d48e13a3308c1c08836d8d.png";

export const FLORAL_ACCENT =
  "https://static.prod-images.emergentagent.com/jobs/e7cab7d0-265b-4a1d-b389-c4d6a5e9545b/images/5bc10bc5bd9c05fe40f5e68ed710f0b9199061d3a3c82ecc13566340d9757231.png";
